import { useState, useEffect } from "react";

import { AsyncPaginate } from "react-select-async-paginate";

import toast from "react-hot-toast";

import { useCustomerViewModel } from "../../../../viewmodels/operation/customer/useCustomerViewModel";

import { useScaleViewModel } from "../../../../viewmodels/operation/scale/useScaleViewModel";

import ScaleMakeAsyncSelect from "../../../../components/common/ScaleMakeAsyncSelect";

import ScaleModelAsyncSelect from "../../../../components/common/ScaleModelAsyncSelect";

interface CreateScaleModalProps {
  customerId?: string;
  customerName?: string;

  onSuccess?: (result: any) => void;

  onCancel?: () => void;
}

const CreateScaleModal = ({
  customerId,
  customerName,
  onSuccess,
  onCancel,
}: CreateScaleModalProps) => {
  useEffect(() => {
    if (!customerId && customerName) {
      setManualCustomer(true);

      setForm((prev) => ({
        ...prev,

        customer: customerName,
      }));
    }
  }, [customerId, customerName]);

  const [addressInput, setAddressInput] = useState("");

  const [selectedMake, setSelectedMake] = useState<any>(null);
  const [selectedModel, setSelectedModel] = useState<any>(null);

  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);

  const [manualCustomer, setManualCustomer] = useState(false);

  const [manualAddress, setManualAddress] = useState(false);

  const [capacityValue, setCapacityValue] = useState("");

  const [capacityUnit, setCapacityUnit] = useState("kg");

  const [divisionValue, setDivisionValue] = useState("");

  const [divisionUnit, setDivisionUnit] = useState("kg");

  const { createScale } = useScaleViewModel();

  const { loadCustomerOptions, loadAddressOptions } = useCustomerViewModel();

  useEffect(() => {
    if (!customerId) return;

    setSelectedCustomer({
      value: customerId,
      label: customerName,
    });

    setForm((prev) => ({
      ...prev,

      customerId,

      customerName: customerName || "",
    }));

    loadDefaultAddress(customerId);
  }, [customerId]);

  const [form, setForm] = useState({
    serialNumber: "",

    isReserved: false,

    identifier: "",

    nmiNumber: "",

    location: "",

    comment: "",

    makeId: "",
    makeName: "",

    modelId: "",
    modelName: "",

    modelCapacityId: null,
    modelCapacity: null,

    customerId: "",
    customerName: "",

    addressId: "",
    addressLine1: "",

    customer: "",
    address: [] as string[],
    make: "",
    model: "",
    capacity: [] as string[],
    capacityText: "",
  });

  const submit = async (e: any) => {
    e.preventDefault();
    // =========================
    // VALIDATION
    // =========================

    if (!manualCustomer && !form.customerId) {
      return toast.error("Customer is required");
    }

    if (manualCustomer && !form.customer.trim()) {
      return toast.error("Customer name is required");
    }

    if (!form.make.trim()) {
      return toast.error("Make is required");
    }

    if (!form.model.trim()) {
      return toast.error("Model is required");
    }

    if (!capacityValue) {
      return toast.error("Capacity is required");
    }

    if (!divisionValue) {
      return toast.error("Division is required");
    }

    if (!capacityUnit) {
      return toast.error("Capacity unit is required");
    }

    if (!divisionUnit) {
      return toast.error("Division unit is required");
    }

    const toNullableGuid = (value: any) => {
      if (value === "" || value === undefined || value === null) {
        return null;
      }

      return value;
    };

    const payload = {
      serialNumber: form.serialNumber,

      isReserved: form.isReserved,

      identifier: form.identifier,

      nmiNumber: form.nmiNumber,

      location: form.location,

      comment: form.comment,

      // =========================
      // EXISTING OR NEW CUSTOMER
      // =========================

      customerId: manualCustomer ? null : toNullableGuid(form.customerId),

      customerName: manualCustomer ? null : form.customerName,

      customer: manualCustomer ? form.customer : null,

      // =========================
      // EXISTING OR NEW ADDRESS
      // =========================

      addressId: manualAddress ? null : toNullableGuid(form.addressId),

      addressLine1: manualAddress ? null : form.addressLine1,

      address: form.address || [],

      makeId: null,
      makeName: null,
      make: form.make,

      modelId: null,
      modelName: null,
      model: form.model,

      modelCapacityId: null,
      modelCapacity: null,

      capacity: [
        `${capacityValue} ${capacityUnit} × ${divisionValue} ${divisionUnit}`,
      ],
    };

    const result = await createScale(payload);
    console.log(result);
    if (result) {
      onSuccess?.({
        customerId: form.customerId || result?.data?.customerId,

        customerName:
          form.customerName || form.customer || result?.data?.customerName,
      });

      setForm((prev) => ({
        ...prev,

        serialNumber: "",
        identifier: "",
        nmiNumber: "",
        location: "",
        comment: "",
        isReserved: false,
      }));
    }
  };

  const loadDefaultAddress = async (customerId: string) => {
    const result = await loadAddressOptions(customerId, "", { page: 1 });

    console.log(result);

    const firstAddress = result?.options?.[0];

    if (firstAddress) {
      console.log(firstAddress);

      const fullAddress = `${firstAddress.data?.addressLine1 || ""}
 ${firstAddress.data?.addressLine2 || ""}
 ${firstAddress.data?.city || ""}
 ${firstAddress.data?.state || ""}
        ${firstAddress.data?.postalCode || ""}`
        .replace(/\s+/g, " ")
        .trim();

      setAddressInput(fullAddress);

      setForm((prev) => ({
        ...prev,

        addressId: firstAddress.value,

        addressLine1: firstAddress.data?.addressLine1 || "",

        address: [fullAddress],
      }));
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl w-full max-w-7xl max-h-[95vh] overflow-y-auto">
        <div className="p-4 md:p-6">
          <div className="flex items-center justify-between mb-6 border-b pb-4">
            <h1 className="text-3xl font-bold">Create Scale</h1>

            <button
              type="button"
              onClick={() => onCancel?.()}
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-slate-100 text-slate-500 hover:text-red-600 transition"
            >
              ✕
            </button>
          </div>

          <form onSubmit={submit} className="space-y-6">
            <div className="bg-white border border-slate-200 rounded-3xl p-6">
              <h2 className="text-xl font-bold mb-6">Scale Details</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
                {/* CUSTOMER */}

                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="block text-sm font-medium">
                      Customer
                    </label>

                    <button
                      type="button"
                      onClick={() => {
                        setManualCustomer(!manualCustomer);

                        setSelectedCustomer(null);

                        setForm((prev) => ({
                          ...prev,

                          customerId: "",
                          customerName: "",
                          customer: "",

                          addressId: "",
                          addressLine1: "",
                          address: [],

                          makeId: "",
                          makeName: "",
                          make: "",

                          modelId: "",
                          modelName: "",

                          modelCapacityId: null,
                          modelCapacity: null,
                        }));
                      }}
                      className="text-xs text-blue-600 hover:underline"
                    >
                      {manualCustomer ? "Select Existing" : "Add New"}
                    </button>
                  </div>

                  {manualCustomer ? (
                    <div className="space-y-3">
                      <div className="flex gap-3">
                        <input
                          value={form.customer}
                          onChange={(e) =>
                            setForm((prev) => ({
                              ...prev,
                              customer: e.target.value,
                            }))
                          }
                          placeholder="Enter Customer"
                          className="flex-1 border border-slate-300 rounded-xl px-4 py-3"
                        />
                      </div>

                      {form.customer && (
                        <div className="bg-blue-50 text-blue-700 px-3 py-2 rounded-xl inline-block">
                          {form.customer}
                        </div>
                      )}
                    </div>
                  ) : (
                    <AsyncPaginate
                      value={selectedCustomer}
                      loadOptions={loadCustomerOptions}
                      additional={{ page: 1 }}
                      onChange={(selected: any) => {
                        if (selected?.isNew) {
                          setManualCustomer(true);

                          setManualAddress(true);

                          setSelectedCustomer(null);

                          setForm((prev) => ({
                            ...prev,

                            customer: selected.customerName,

                            customerId: "",
                            customerName: "",

                            addressId: "",
                            addressLine1: "",
                            address: [],
                          }));

                          return;
                        }

                        setSelectedCustomer(selected);

                        setManualCustomer(false);

                        setForm((prev) => ({
                          ...prev,

                          customerId: selected?.value || "",

                          customerName: selected?.label || "",
                        }));

                        if (selected?.value) {
                          loadDefaultAddress(selected.value);
                        }
                      }}
                    />
                  )}
                </div>

                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="block text-sm font-medium">Address</label>
                  </div>
                  <input
                    value={addressInput}
                    onChange={(e) => {
                      const value = e.target.value;

                      setAddressInput(value);

                      setForm((prev) => ({
                        ...prev,

                        addressId: "",

                        addressLine1: value,

                        address: value ? [value] : [],
                      }));
                    }}
                    placeholder="Enter Address"
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Make</label>

                  <ScaleMakeAsyncSelect
                    value={selectedMake}
                    onChange={(selected: any) => {
                      setSelectedMake(selected);
                      setSelectedModel(null);

                      setForm((prev: any) => ({
                        ...prev,
                        makeId: selected?.__isNew__ ? null : selected?.value,
                        make: selected?.label ?? "",

                        modelId: null,
                        model: "",
                      }));
                    }}
                  />
                </div>

                {/* MODEL */}

                <div>
                  <label className="block text-sm font-medium mb-2">
                    Model
                  </label>

                  <ScaleModelAsyncSelect
                    value={selectedModel}
                    onChange={(selected: any) => {
                      setSelectedModel(selected);

                      if (!selected) {
                        setForm((prev: any) => ({
                          ...prev,
                          modelId: null,
                          model: "",
                          capacityValue: "",
                          division: "",
                          capacityUnit: "kg",
                          capacity: "",
                        }));
                        return;
                      }

                      const modelCapacity = selected.capacities?.[0];

                      const capacityValue =
                        modelCapacity?.capacity?.toString() ?? "";

                      const division =
                        modelCapacity?.division?.toString() ?? "";

                      const capacityUnit =
                        modelCapacity?.capacityUnitName ?? "kg";

                      const divisionUnit =
                        modelCapacity?.divisionUnitName ?? capacityUnit;

                      setForm((prev: any) => ({
                        ...prev,

                        modelId: selected.__isNew__ ? null : selected.value,
                        model: selected.label,

                        // Populate these fields first
                        capacityValue,
                        division,
                        capacityUnit,

                        // Then build the display string
                        capacity:
                          capacityValue && division
                            ? `${capacityValue}${capacityUnit}x${division}${divisionUnit}`
                            : "",
                      }));
                    }}
                  />
                </div>

                {/* CAPACITY */}

                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="block text-sm font-medium">
                      Capacity
                    </label>
                  </div>

                  <div className="space-y-3">
                    <div className="grid grid-cols-4 gap-3">
                      <input
                        type="number"
                        step="0.001"
                        placeholder="Capacity"
                        value={capacityValue}
                        onChange={(e) => {
                          const value = e.target.value;

                          setCapacityValue(value);

                          const capacityText =
                            value && divisionValue
                              ? `${divisionValue}${divisionUnit} × ${value}${capacityUnit}`
                              : "";

                          setForm((prev) => ({
                            ...prev,

                            capacity: capacityText ? [capacityText] : [],
                          }));
                        }}
                        className="border border-slate-300 rounded-xl px-4 py-3"
                      />

                      <select
                        value={capacityUnit}
                        onChange={(e) => setCapacityUnit(e.target.value)}
                        className="border border-slate-300 rounded-xl px-4 py-3"
                      >
                        <option value="mg">mg</option>
                        <option value="g">g</option>
                        <option value="kg">kg</option>
                        <option value="t">t</option>
                        <option value="lb">lb</option>
                        <option value="oz">oz</option>
                      </select>

                      <input
                        type="number"
                        step="0.001"
                        placeholder="Division"
                        value={divisionValue}
                        onChange={(e) => {
                          const value = e.target.value;

                          setDivisionValue(value);

                          const capacityText =
                            capacityValue && value
                              ? `${value}${divisionUnit} × ${capacityValue}${capacityUnit}`
                              : "";

                          setForm((prev) => ({
                            ...prev,

                            capacity: capacityText ? [capacityText] : [],
                          }));
                        }}
                        className="border border-slate-300 rounded-xl px-4 py-3"
                      />

                      <select
                        value={divisionUnit}
                        onChange={(e) => setDivisionUnit(e.target.value)}
                        className="border border-slate-300 rounded-xl px-4 py-3"
                      >
                        <option value="mg">mg</option>
                        <option value="g">g</option>
                        <option value="kg">kg</option>
                        <option value="t">t</option>
                        <option value="lb">lb</option>
                        <option value="oz">oz</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* SERIAL */}

                <div>
                  <label className="block text-sm font-medium mb-2">
                    Serial Number
                  </label>

                  <input
                    value={form.serialNumber}
                    onChange={(e) =>
                      setForm({
                        ...form,

                        serialNumber: e.target.value,
                      })
                    }
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                </div>

                {/* IDENTIFIER */}

                <div>
                  <label className="block text-sm font-medium mb-2">Id</label>

                  <input
                    value={form.identifier}
                    onChange={(e) =>
                      setForm({
                        ...form,

                        identifier: e.target.value,
                      })
                    }
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                </div>

                {/* NMI */}

                <div>
                  <label className="block text-sm font-medium mb-2">
                    NMI Number
                  </label>

                  <input
                    value={form.nmiNumber}
                    onChange={(e) =>
                      setForm({
                        ...form,

                        nmiNumber: e.target.value,
                      })
                    }
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                </div>

                {/* LOCATION */}

                <div>
                  <label className="block text-sm font-medium mb-2">
                    Location
                  </label>

                  <input
                    value={form.location}
                    onChange={(e) =>
                      setForm({
                        ...form,

                        location: e.target.value,
                      })
                    }
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                </div>
              </div>
            </div>

            {/* COMMENTS */}

            <div className="bg-white border border-slate-200 rounded-3xl p-6">
              <h2 className="text-xl font-bold mb-5">Additional Information</h2>

              <div className="space-y-5">
                <div>
                  <label className="block text-sm font-medium mb-2">
                    Comment
                  </label>

                  <textarea
                    rows={4}
                    value={form.comment}
                    onChange={(e) =>
                      setForm({
                        ...form,

                        comment: e.target.value,
                      })
                    }
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                </div>

                {/* <div>
                  <label className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      checked={form.isReserved}
                      onChange={(e) =>
                        setForm({
                          ...form,

                          isReserved: e.target.checked,
                        })
                      }
                    />

                    <span>Reserved Scale</span>
                  </label>
                </div> */}
              </div>
            </div>

            {/* BUTTONS */}

            <div className="flex justify-end gap-3">
              <button
                type="button"
                onClick={() => onCancel?.()}
                className="px-6 py-3 border rounded-2xl"
              >
                Cancel
              </button>

              <button
                type="submit"
                className="bg-primary text-white px-8 py-3 rounded-2xl font-semibold"
              >
                Save Scale
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateScaleModal;
